// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__s-8iW","calendarButtons":"ClockData_calendarButtons__2kZ-o"};